module.exports = __webpack_public_path__ + "img/icon_enter.fb226f2b.svg";